import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledBox = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  '& .PPVNoteText': {
    color: theme.palette.secondary.main,
    margin: theme.spacing(4.5, 0, 3, 0),
    [theme.breakpoints.down('lg')]: {
      margin: theme.spacing(2.625, 0, 3, 0),
    },
    [theme.breakpoints.down('md')]: {
      margin: theme.spacing(2, 0, 3, 0),
    },
  },
}));

export default StyledBox;
